'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_api_UsersEditRequest(user, organization) {
  this.Bl = null;
  this.KC = null;
  this.Bl = user;
  this.KC = organization;
}
export { $c_Lapp_api_UsersEditRequest as $c_Lapp_api_UsersEditRequest };
$p = $c_Lapp_api_UsersEditRequest.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_api_UsersEditRequest;
/** @constructor */
function $h_Lapp_api_UsersEditRequest() {
}
export { $h_Lapp_api_UsersEditRequest as $h_Lapp_api_UsersEditRequest };
$h_Lapp_api_UsersEditRequest.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_UsersEditRequest)) {
    var x = this.Bl;
    var x$2 = x$0.Bl;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.KC;
      var x$4 = x$0.KC;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "UsersEditRequest";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Bl;
  }
  if ((n === 1)) {
    return this.KC;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "user";
  }
  if ((n === 1)) {
    return "organization";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_api_UsersEditRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iA)));
}
export { $isArrayOf_Lapp_api_UsersEditRequest as $isArrayOf_Lapp_api_UsersEditRequest };
var $d_Lapp_api_UsersEditRequest = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_api_UsersEditRequest, "app.api.UsersEditRequest", ({
  iA: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_api_UsersEditRequest as $d_Lapp_api_UsersEditRequest };
//# sourceMappingURL=app.api.-Users-Edit-Request.js.map
